import { Tabs, Title, Group, Text, Badge } from '@mantine/core'
import { IconTag, IconGavel, IconFileText, IconScale, IconBuildingBank } from '@tabler/icons-react'
import { useState } from 'react'
import { CrimeCategoryTable } from './labeling/CrimeCategoryTable'
import { ChargeLabelTable } from './labeling/ChargeLabelTable'
import { SourceLabelTable } from './labeling/SourceLabelTable'

export function LabelingPage() {
  const [activeTab, setActiveTab] = useState<string | null>('charges')

  return (
    <div>
      <Group justify="space-between" mb="lg">
        <Group gap="sm">
          <IconTag size={28} stroke={1.5} />
          <Title order={2}>Labeling</Title>
        </Group>
        <Text size="sm" c="dimmed">
          Review and correct classification cache tables
        </Text>
      </Group>

      <Tabs value={activeTab} onChange={setActiveTab}>
        <Tabs.List mb="md">
          <Tabs.Tab value="charges" leftSection={<IconGavel size={16} />}>
            Charges
          </Tabs.Tab>
          <Tabs.Tab value="sources" leftSection={<IconBuildingBank size={16} />}>
            Sources
          </Tabs.Tab>
          <Tabs.Tab value="crime-category" leftSection={<IconScale size={16} />}>
            Crime Category
          </Tabs.Tab>
          <Tabs.Tab value="disposition" leftSection={<IconFileText size={16} />} disabled>
            <Group gap={6}>
              Disposition
              <Badge size="xs" variant="light" color="gray">Soon</Badge>
            </Group>
          </Tabs.Tab>
          <Tabs.Tab value="offense-type" leftSection={<IconScale size={16} />} disabled>
            <Group gap={6}>
              Offense Type
              <Badge size="xs" variant="light" color="gray">Soon</Badge>
            </Group>
          </Tabs.Tab>
        </Tabs.List>

        <Tabs.Panel value="charges">
          <ChargeLabelTable />
        </Tabs.Panel>

        <Tabs.Panel value="sources">
          <SourceLabelTable />
        </Tabs.Panel>

        <Tabs.Panel value="crime-category">
          <CrimeCategoryTable />
        </Tabs.Panel>

        <Tabs.Panel value="disposition">
          <Text c="dimmed" ta="center" py="xl">Coming soon</Text>
        </Tabs.Panel>

        <Tabs.Panel value="offense-type">
          <Text c="dimmed" ta="center" py="xl">Coming soon</Text>
        </Tabs.Panel>
      </Tabs>
    </div>
  )
}
